import { render } from "./updateClientSourse.html?vue&type=template&id=59fc0b2c&scoped=true&ts=true&external"
import script from "./UpdateClientSourse.vue?vue&type=script&lang=ts"
export * from "./UpdateClientSourse.vue?vue&type=script&lang=ts"

import "./UpdateClientSourse.vue?vue&type=style&index=0&id=59fc0b2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fc0b2c"]])

export default __exports__